import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { Title, Item, Link, Status } from "./components";
import Participants from "./containers/Participants";
import Actions from "./containers/Actions";
import Logs from "./containers/Logs";
import { I18n, translate } from "@td/shared_utils";
import { useCallStatus } from "../call-details/CallStatusProvider";
import SunriseLink from "./containers/SunriseLink";

const WaitingRoomSidebar = ({ consultation, forceAudioConference, visitType, currentUser }) => {
  const {
    member,
    consultationId,
  } = consultation;

  const { status, startedAt, attendees } = useCallStatus();

  return (
    <div className={styles.sidebarContainer}>
      <Status
        status={status}
        startedAt={startedAt}
      />

      <Title>
        <I18n scope="call_details" text="consult" />
      </Title>
      <Item
        label={`${translate(null, "call_details.consult_labels", "id")}:`}
        value={
          <Link href={Routes.consultation_path(consultationId)}>
            {consultationId}
          </Link>
        }
      />

      { window.FEATURE_TOGGLES.allscript_api_enabled &&
      <Item
        label="Sunrise:"
        value={<SunriseLink memberId={member.memberId}/>}
      />
      }

      <Item
        label={`${translate(null, "call_details.consult_labels", "reason_for_visit")}:`}
        value={consultation.consultRequestReasonUft}
      />

      <Participants
        consultationId={consultationId}
        member={{
          id: member.memberId,
          fullName: `${member.firstNm} ${member.lastNm}`,
        }}
        provider={{
          id: consultation.providerId,
          fullName: consultation.providerNm,
        }}
        attendeeStatuses={attendees}
        visitType={visitType}
      />
      <Actions
        consultation={consultation}
        currentUser={currentUser}
      />

      <Logs
        consultationId={consultationId}
        forceAudioConference={forceAudioConference}
      />
    </div>
  );
};

WaitingRoomSidebar.propTypes = {
  consultation: PropTypes.object.isRequired,
  forceAudioConference: PropTypes.bool,
  visitType: PropTypes.string.isRequired,
};

export default WaitingRoomSidebar;
